import React, { useState } from "react"
import { Card, Button, Tag, Flex, Typography } from "antd"
import { spacings } from "themes/variables"
import { MAX_CHARACTERISTICS_DISPLAY, MAX_DESCRIPTION_LENGTH } from "../../../constants"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const { Title, Paragraph } = Typography

/**
 * DetailsCard component displays equipment description and characteristics
 * @param {string} description - Equipment description
 * @param {Array} characteristics - Array of characteristic objects
 * @param {Function} t - Translation function
 */
const DetailsCard = ({ description = "", characteristics = [], t }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  // Truncation logic
  const isDescriptionLong = description.length > MAX_DESCRIPTION_LENGTH
  const hasManyCharacteristics = characteristics.length > MAX_CHARACTERISTICS_DISPLAY

  const shouldShowSeeMore = isDescriptionLong || hasManyCharacteristics

  const displayDescription = isExpanded || !isDescriptionLong ? description : description.substring(0, MAX_DESCRIPTION_LENGTH) + "..."

  const displayCharacteristics = isExpanded || !hasManyCharacteristics ? characteristics : characteristics.slice(0, MAX_CHARACTERISTICS_DISPLAY)

  const handleToggleDetails = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Card className={styles.detailsCard}>
      <Title level={4}>{t("equipment.details.details_title")}</Title>
      <div className={styles.scrollContainer}>
        <Paragraph className={styles.description}>{displayDescription || t("equipment.details.no_description")}</Paragraph>

        {/* Characteristics */}
        {displayCharacteristics.length > 0 && (
          <Flex gap={spacings.XXS} wrap="wrap" className={styles.characteristics}>
            {displayCharacteristics.map((char) => (
              <Tag key={char.id} className={styles.characteristicTag}>
                {char.name}
              </Tag>
            ))}
          </Flex>
        )}

        {shouldShowSeeMore && (
          <Button type="link" className={styles.seeMore} onClick={handleToggleDetails}>
            {isExpanded ? t("equipment.details.see_less") : t("equipment.details.see_more")}
          </Button>
        )}
      </div>
    </Card>
  )
}

DetailsCard.propTypes = {
  description: PropTypes.string,
  characteristics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  t: PropTypes.func.isRequired
}

DetailsCard.defaultProps = {
  description: "",
  characteristics: []
}

export default DetailsCard
